class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.querySelector('.menu-drawer');
    this.overlay = document.querySelector('body > .overlay');
    this.closeButtons = this.querySelectorAll('.button-close');
    this.section =
      document.querySelector('#shopify-section-menu-drawer') ||
      document.querySelector('#shopify-section-mega-menu-drawer');

    this.isOpen = false;

    // Bind once
    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.onKeyup = this.onKeyup.bind(this);
    this.onResize = this.debounce(this.updatePinnedHeight.bind(this), 150);

    document.addEventListener('click', this.handleBurgerClick.bind(this));
    document.addEventListener('keyup', this.onKeyup);

    this.closeButtons.forEach(btn =>
      btn.addEventListener('click', this.closeDrawer)
    );

    if (this.overlay) {
      this.overlay.addEventListener('click', this.closeDrawer);
    }

    window.addEventListener('resize', this.onResize);

    if (Shopify.designMode && this.section) {
      this.section.addEventListener('shopify:section:select', this.openDrawer);
      this.section.addEventListener('shopify:section:deselect', this.closeDrawer);
    }
  }

  handleBurgerClick(e) {
    const burger = e.target.closest('.burger-menu');
    if (!burger) return;
    this.openDrawer();
  }

  onKeyup(e) {
    if (e.code === 'Escape' && this.isOpen) {
      this.closeDrawer();
    }
  }

  openDrawer() {
    if (this.isOpen) return;
    this.isOpen = true;

    this.drawer.removeAttribute('hidden');

    requestAnimationFrame(() => {
      this.drawer.classList.add('open');
    });

    document.body.classList.add('hidden');
    if (this.overlay) this.overlay.classList.add('open');

    this.updatePinnedHeight();
  }

  closeDrawer() {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.drawer.setAttribute('hidden', '');
    this.drawer.classList.remove('open');
    document.body.classList.remove('hidden');
    if (this.overlay) this.overlay.classList.remove('open');
  }

  updatePinnedHeight() {
    const pinned = this.drawer.querySelector('.pinned-block');
    const nested = this.drawer.querySelector('.nested-submenu');

    if (!pinned || !nested) return;

    this.drawer.style.setProperty(
      '--height-pinned-block',
      `${pinned.offsetHeight + 16}px`
    );
  }

  debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

customElements.define('menu-drawer', MenuDrawer);
